import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=17e5c0a2&"
import script from "./talk.vue?vue&type=script&lang=js&"
export * from "./talk.vue?vue&type=script&lang=js&"
import style0 from "./talk.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports